<cmps-dialog>
    <cmps-dialog-header>
        <div class="cmps-mi2-population-group-dialog--header">
            {{ _i18n._9867_SCORECARD_CATEGORIES | translate }}
        </div>
    </cmps-dialog-header>
    <cmps-dialog-body>
        <div class="cmps-mi2-population-group-dialog--table">
            <div class="cmps-mi2-population-group-dialog--table-row-header">
                <div>
                    {{ _i18n._9868_PREVIOUS_SCORECARD_CATEGORY | translate }}
                </div>
                <div>{{ _i18n._9869_CURRENT_CATEGORY | translate }}</div>
                <div>{{ _i18n._9853_IMPROVEMENT_CATEGORY | translate }}</div>
                <div>{{ _i18n._9878_MI2_SCORE | translate }}</div>
            </div>
            <div
                class="cmps-mi2-population-group-dialog--table-row"
                *ngFor="let c of _data?.populationGroupImprovementGroups"
            >
                <div>{{ c?.previousClass?.scorecardPerformanceClassName }}</div>
                <div>{{ c?.currentClass?.scorecardPerformanceClassName }}</div>
                <div>
                    <button
                        class="cmps-mi2-population-group-dialog--category-button"
                        cmpsButton
                        [style.background-color]="c?.colour"
                        role="presentation"
                    >
                        <span cmpsButtonLabel>{{
                            c?.scorecardImprovementGroupName
                        }}</span>
                    </button>
                </div>
                <div>
                    <button
                        class="cmps-mi2-population-group-dialog--category-button"
                        cmpsButton
                        [style.background-color]="c?.colour"
                        role="presentation"
                    >
                        <span cmpsButtonLabel>{{
                            c?.points / 100 | cmpsPercent: '1.0-0'
                        }}</span>
                    </button>
                </div>
            </div>
        </div>
    </cmps-dialog-body>
</cmps-dialog>
